// 📄 pages/Proyectos/components/incidenteStyles.ts
// Estilos compartidos entre IncidenteCard y IncidenteDetailModal.
import { IncidentePrioridad, IncidenteEstado, IncidenteAmbiente } from '../../../services/incidenteService.ts';

export const PRIORIDAD_STYLES: Record<IncidentePrioridad, string> = {
  'Crítica': 'bg-red-500/10 text-red-400 border-red-500/30',
  'Alta': 'bg-orange-500/10 text-orange-400 border-orange-500/30',
  'Media': 'bg-yellow-500/10 text-yellow-400 border-yellow-500/30',
  'Baja': 'bg-gray-500/10 text-gray-400 border-gray-500/30'
};

export const ESTADO_STYLES: Record<IncidenteEstado, string> = {
  'Abierto': 'bg-blue-500/10 text-blue-400 border-blue-500/30',
  'En progreso': 'bg-indigo-500/10 text-indigo-400 border-indigo-500/30',
  'Resuelto': 'bg-emerald-500/10 text-emerald-400 border-emerald-500/30',
  'Cerrado': 'bg-gray-500/10 text-gray-400 border-gray-500/30'
};

// PRD en ámbar: es el ambiente donde un incidente pesa más (mismo criterio
// de "llamar la atención" que ya usa PRIORIDAD_STYLES con Alta/Crítica).
export const AMBIENTE_STYLES: Record<IncidenteAmbiente, string> = {
  'DEV': 'bg-gray-500/10 text-gray-400 border-gray-500/30',
  'QAS': 'bg-sky-500/10 text-sky-400 border-sky-500/30',
  'PRD': 'bg-amber-500/10 text-amber-400 border-amber-500/30',
  'Todos': 'bg-purple-500/10 text-purple-400 border-purple-500/30'
};
